// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"505":"afd29cd817db31bf6ef2","511":"32f426e45def9d46a1bb","680":"7ab24d410d90ff4216e0","986":"c895aa042403865f2c70"}[chunkId] + ".js";
};